




































































import { Employee } from "@/api";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NavigationItem extends Vue {
  @Prop() icon!: string;
  @Prop() label!: string;
  @Prop() secondaryLabel?: string;
  @Prop() rootPath!: string;
  @Prop() fetchPrimaryNotice!: string;
  @Prop() fetchSecondaryNotice!: string;
  @Prop() noticeColor!: string;
  @Prop() noticeColorSecondary!: string;
  // eslint-disable-next-line
  @Prop() primaryFilter?: (items: any) => any;
  // eslint-disable-next-line
  @Prop() secondaryFilter?: (items: any) => any;

  isSelected() {
    if (this.rootPath == "/") {
      return this.$route.path == "/";
    } else {
      return this.$route.path.startsWith(this.rootPath);
    }
  }

  isPrimary() {
    return this.noticeColor == "primary";
  }

  go() {
    this.$router.push({ path: this.rootPath });
  }

  get self(): Employee {
    return this.$store.getters["getCurrentEmployeeSelf"];
  }

  get isSuperAdmin() {
    return this.$store.getters["isSuperAdmin"];
  }

  get isOpen() {
    return this.$store.state.navigationRailIsOpen;
  }

  get primaryNotice() {
    if (!this.fetchPrimaryNotice) {
      return 0;
    }
    let count = this.$store.getters[this.fetchPrimaryNotice];
    if (this.primaryFilter) {
      count = this.primaryFilter(count);
    }
    return count?.count || 0;
  }

  get secondaryNotice() {
    if (!this.fetchSecondaryNotice) {
      return 0;
    }
    let count = this.$store.getters[this.fetchSecondaryNotice];
    if (this.secondaryFilter) {
      count = this.secondaryFilter(count);
    }
    return count?.count || 0;
  }
}
